import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

import CountryLink from 'Components/common/CountryLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { getCountryOverallTrend } from 'Utils/calcOverallTrend';

const SummaryRow = (props) => {
  const { globalStatistics, isoAlpha2, priorityGroups, showDetail, setShowDetail } = props;
  const casesPercentOfPeak = globalStatistics.distributionRanks.cases[isoAlpha2];
  const deathsPercentOfPeak = globalStatistics.distributionRanks.deaths[isoAlpha2];
  const trend = getCountryOverallTrend(globalStatistics, isoAlpha2);
  const nationalJurisdiction = priorityGroups.jurisdictions.find(j => j.name === null);

  const humanizePercent = (percent) => {
    const p = parseInt(percent * 100);
    if (p < 1) return '<1%';
    if (p > 99) return 'Peak';
    return `${p}%`;
  };

  return (
    <div
      className={classnames(component)}
      onClick={() => setShowDetail(!showDetail)}
    >

      <div className={classnames('row', { expanded: Boolean(showDetail) })}>
        <div className='country-name inline'>
          <CountryLink country={props.isoAlpha2} />
        </div>
        <div className='cases-trend trend inline'>
          {casesPercentOfPeak ? (
            <>
              <span>{humanizePercent(casesPercentOfPeak)}</span>
              <span>
                {(trend.cases && trend.cases.increasing) && (
                  <FontAwesomeIcon icon={faCaretUp} />
                )}
                {(trend.cases && trend.cases.decreasing) && (
                  <FontAwesomeIcon icon={faCaretDown} />
                )}
              </span>
            </>
          ): null}
        </div>
        <div className='deaths-trend trend inline'>
          {deathsPercentOfPeak ? (
            <>
              <span>{humanizePercent(deathsPercentOfPeak)}</span>
              <span>
                {(trend.deaths && trend.deaths.increasing) && (
                  <FontAwesomeIcon icon={faCaretUp} />
                )}
                {(trend.deaths && trend.deaths.decreasing) && (
                  <FontAwesomeIcon icon={faCaretDown} />
                )}
              </span>
            </>
          ) : null}
        </div>
        <div className='vaccinated inline'>

          <div className='bar-backer inline'>
            <div className='bar' style={{ width: props.vaccinatedPercentOfPop * 100 + '%' }} />
          </div>
          <div className='bar-label inline'>
            <p>{humanizePercent(props.vaccinatedPercentOfPop)}</p>
          </div>
        </div>
        <div className='phase-progress inline'>
          {(
            nationalJurisdiction &&
          nationalJurisdiction.phaseProgress[0] > 0
          ) ? (
            <>
              <div className='current-phase inline'>
                <div className='bullet'>
                  {nationalJurisdiction.phaseProgress[0]}
                </div>

              </div>
              <div className='total-phases inline'>
                of {nationalJurisdiction.phaseProgress[1]}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SummaryRow;
